import React from "react";
import Data from "../assets/Data.js";
const Timeline = () => {
  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />

      <br />
      <div id="timeline">
        <div className="timelineBox">
          {Data.map((item, index) => (
            <TimelineItem
              heading={item.title}
              text={item.date}
              index={index}
              key={item.title}
            />
          ))}
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </>
  );
};

const TimelineItem = ({ heading, text, index }) => (
  <div
    className={`timelineItem ${
      index % 2 === 0 ? "leftTimeline" : "rightTimeline"
    }`}
  >
    <div>
      <h2>{heading}</h2>
      <p>{text}</p>
    </div>
  </div>
);

export default Timeline;
